import Nav from "../Nav";

export default function Landing() {
  return (
    <div id="landing">
      <Nav />
      <section id="intro">
        <div id="intro-container">
          <h1>
            Paul <span>Vera</span>
          </h1>
          <h3>Front-End Developer</h3>
          <p>
            I am a learner. I am a problem solver. I am an optimist. I am a
            developer.
          </p>
          <a href="#experience" className="btn-two">
            <span className="landing--h--letter">E</span>
            <span className="landing--h--letter">x</span>
            <span className="landing--h--letter">p</span>
            <span className="landing--h--letter">e</span>
            <span className="landing--h--letter">r</span>
            <span className="landing--h--letter">i</span>
            <span className="landing--h--letter">e</span>
            <span className="landing--h--letter">n</span>
            <span className="landing--h--letter">c</span>
            <span className="landing--h--letter">e</span>
            <span className="hidden-leter">|</span>
            <span className="landing--h--letter">&</span>
            <span className="hidden-leter">|</span>
            <span className="landing--h--letter">C</span>
            <span className="landing--h--letter">e</span>
            <span className="landing--h--letter">r</span>
            <span className="landing--h--letter">t</span>
            <span className="landing--h--letter">i</span>
            <span className="landing--h--letter">f</span>
            <span className="landing--h--letter">i</span>
            <span className="landing--h--letter">c</span>
            <span className="landing--h--letter">a</span>
            <span className="landing--h--letter">t</span>
            <span className="landing--h--letter">i</span>
            <span className="landing--h--letter">o</span>
            <span className="landing--h--letter">n</span>
            <span className="landing--h--letter">s</span>
          </a>
        </div>
      </section>
    </div>
  );
}
